import React, { createContext, useContext, useState,useEffect } from "react";
import Web3 from "web3";
import swal from "sweetalert"
import WalletConnectProvider  from '@walletconnect/web3-provider';
import * as Airdrop from '../common';

const WalletContext = createContext(null);

export const useWallet = () => useContext(WalletContext);

function WalletProvider({ children }) {
  const [walletAccount, setWalletAccount] = useState(null);
  const [wallet, setWallet] = useState({});
  const [currencyData, setCurrencyData] =useState({
    node: 'goerli',
    rpcUrl: 'https://goerli.infura.io/v3/62d7de656d544930adb16c024a8694bf',
    endPoint: 'api-goerli.etherscan.io',
    networkType:"GOERLI",
    chainId : "5",
    airDropContract : Airdrop.EthAirdropContract,
    web3Obj : Airdrop.web3ETH,
    airdropAddress: Airdrop.EthAirdropAddress,
    blockexplorer: "goerli.etherscan.io"
  })

  

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const currency = queryParams.get("currency");
    async function setCurrencyValues(){
        switch (currency) {
            case "eth":
                setCurrencyData({
                    node: 'goerli',
                    rpcUrl: 'https://goerli.infura.io/v3/62d7de656d544930adb16c024a8694bf',
                    endPoint: 'api-goerli.etherscan.io',
                    networkType:"GOERLI",
                    chainId : "5",
                    airDropContract : Airdrop.EthAirdropContract,
                    web3Obj : Airdrop.web3ETH,
                    airdropAddress: Airdrop.EthAirdropAddress,
                    blockexplorer: "goerli.etherscan.io"
                  });
              break;
            case "bnb":
                setCurrencyData({
                    node: 'private',
                    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
                    endPoint: 'api-testnet.bscscan.com',
                    networkType:"BINANCE",
                    chainId : "97",
                    airDropContract : Airdrop.BscAirdropContract,
                    web3Obj : Airdrop.web3BSC,
                    airdropAddress: Airdrop.BscAirdropAddress,
                    blockexplorer: "testnet.bscscan.com"
                  });
              break;
              case "avax":
                setCurrencyData({
                    node: 'private',
                    rpcUrl: 'https://api.avax-test.network/ext/bc/C/rpc',
                    endPoint: 'api-testnet.snowtrace.io',
                    networkType:"AVALANCHE",
                    chainId : "43113",
                    airDropContract : Airdrop.AvaxAirdropContract,
                    web3Obj : Airdrop.web3Avax,
                    airdropAddress: Airdrop.AvaxAirdropAddress,
                    blockexplorer: "testnet.snowtrace.io"
                  });
              break;
              case "matic":
                setCurrencyData({
                    node: 'private',
                    rpcUrl: 'https://matic-mumbai.chainstacklabs.com',
                    endPoint: 'api-testnet.polygonscan.com',
                    networkType:"MATIC",
                    chainId : "80001",
                    airDropContract : Airdrop.MaticAirdropContract,
                    web3Obj : Airdrop.web3Matic,
                    airdropAddress: Airdrop.MaticAirdropAddress,
                    blockexplorer: "mumbai.polygonscan.com"
                  });
              break;
              case "trx":
                setCurrencyData({
                    node: 'TRX',
                    // rpcUrl: 'https://matic-mumbai.chainstacklabs.com',
                    endPoint: 'api.shasta.trongrid.io',
                    networkType:"TRON",
                    chainId : "0",
                    airDropContract : Airdrop.TronAirdropContract(),
                    // web3Obj : Airdrop.web3Matic,
                    airdropAddress: Airdrop.TronAirdropAddress,
                    blockexplorer: "shasta.tronscan.org"
                  });
              break;
            default:
                setCurrencyData({
                      node: 'goerli',
                      rpcUrl: 'https://goerli.infura.io/v3/62d7de656d544930adb16c024a8694bf',
                      endPoint: 'api-goerli.etherscan.io',
                      networkType:"GOERLI",
                      chainId : "5",
                      airDropContract : Airdrop.EthAirdropContract,
                      web3Obj : Airdrop.web3ETH,
                      airdropAddress: Airdrop.EthAirdropAddress,
                      blockexplorer: "goerli.etherscan.io"
                    });  
          }
      }
     setCurrencyValues();
  }, [])
  
  
  

  const provider  = new WalletConnectProvider({
    rpc: {
        1: "https://mainnet.infura.io/v3/62d7de656d544930adb16c024a8694bf"
      },
    bridge: "https://bridge.walletconnect.org", // Required
  });

  const connectWalletConnect = async () => {
    // Send JSON RPC requests
    if(!provider.connected){
        await provider.enable();
    }
    subscribeToEvents();
  }

  const subscribeToEvents = () => {

    if (!provider.connected) {
      return;
    }

    // Subscribe to accounts change
      provider.on("accountsChanged", (accounts) => {
        sessionStorage.removeItem("address")
        const address = accounts[0];
        sessionStorage.setItem("address", address)
        setWalletAccount(address)
      });

      // Subscribe to chainId change
      provider.on("chainChanged", (chainId) => {
        console.log(chainId);
      });

      // Subscribe to session disconnection
      provider.on("disconnect", (code, reason) => {
        console.log(code, reason);
        sessionStorage.removeItem("address")
        setWallet({});
      });

    if (provider.connected) {
      const { chainId, accounts } = provider;
      const address = accounts[0];
      sessionStorage.setItem("address", address)
      setWalletAccount(address)
      setWallet({
        connected: true,
        chainId,
        accounts,
        address,
      });
    }
  }

  const logout = async ()=>{
    await provider.disconnect();
    subscribeToEvents();
  }
  var web3 = new Web3(Web3.givenProvider || currencyData.rpcUrl);


  async function tronConnect() {
    const node = "https://api.shasta.trongrid.io";
    if (window.tronWeb) {
      // if (window.tronWeb.defaultAddress.base58) {
      if (window.tronWeb.defaultAddress.base58) {
        if(window.tronWeb.fullNode.host === node){
          const address = window.tronWeb.defaultAddress?.base58 || '';
          sessionStorage.setItem("address", address);
          setWalletAccount(address)
        }else{
          swal("Please connect to Shasta Testnet", { buttons: false, icon: "error", timer: 3000 });
        }
        
      } else {
        swal("Please unlock Tron link wallet", { buttons: false, icon: "error", timer: 3000 });
      }
    } else {
      swal("Please install Tron link wallet", { buttons: false, icon: "error", timer: 3000 });
    }
  }

  const metamaskconn = async () => {
    window.test = web3
    if (web3.givenProvider !== null) {

        web3.givenProvider.enable().then(async function (address) {
            if (parseInt(await web3.givenProvider.networkVersion) === Number(currencyData.chainId)) {
                web3.eth.getAccounts().then(async (account) => {
                    sessionStorage.setItem("address", account[0]);
                    setWalletAccount(account[0])
                })
            } else {
                swal(`Please select ${currencyData.networkType} Wallet`, {
                    button: false,
                    icon: "warning",
                    timer: 3000
                })
            }
        }).catch(function (err) {
            swal(err.message, {
                button: false,
                icon: "warning"
            })
        });
    } else {
        swal("Please install Metamask wallet", {
            button: false,
            icon: "warning"
        });
    }
}

  return (
    <WalletContext.Provider
      value={{
        wallet,
        setWallet,
        account:  walletAccount || ( sessionStorage.address !== 'undefined' && sessionStorage.address ),
        connectWalletConnect,
        logout,
        currencyDetails:currencyData,
        metamaskconn,
        tronConnect
      }}
    >
      {children}
    </WalletContext.Provider>
  );
}

export default WalletProvider;
